module.exports = __webpack_public_path__ + "static/media/dota3.5b8df38d.gif";